module.exports = __webpack_public_path__ + "static/media/buttonsounds07.439bf370.wav";